(() => {
  function applyToForm(form) {
    if (form.dataset._variantSelectedInit) return;
    form.dataset._variantSelectedInit = "1";

    const updateGroup = (name) => {
      const inputs = form.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`);
      inputs.forEach(inp => {
        const label = form.querySelector(`label.radio__label[for="${CSS.escape(inp.id)}"]`);
        if (label) label.classList.toggle("is-selected", inp.checked);
      });
    };

    // Init all groups on load
    form.querySelectorAll('input[type="radio"][name]').forEach(inp => updateGroup(inp.name));

    // Listen for changes
    form.addEventListener("change", (e) => {
      const t = e.target;
      if (t.matches('input[type="radio"][name]')) updateGroup(t.name);
    });
  }

  function initAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(applyToForm);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAll();
    // Re-init for quick views/AJAX-loaded sections
    new MutationObserver(() => initAll())
      .observe(document.body, { childList: true, subtree: true });
  });
})();
